const imageUploadErrorTypes = {
  FILE_INVALID_TYPE: 'file-invalid-type',
  TOO_MANY_FILES: 'too-many-files',
  FILE_TOO_LARGE: 'file-too-large',
};

export { imageUploadErrorTypes };
